module.exports = __webpack_public_path__ + "static/media/Apples Script Demo-01.9d55a4b8.svg";